import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';



import BlankState from '../../../components/BlankState';
import StatusMessages2 from '../../../components/StatusMessages2';

import { saveBrokerPartnership, updateBroker } from '../../../actions/brokers';
import { listInsurers } from './../../../actions/insurers';
import SimpleReactValidator from 'simple-react-validator';

class BrokerPartnershipsForm extends Component{

    constructor(props){
        super(props);

        this.validator=new SimpleReactValidator();

        this.state = {
            broker: {
                ...this.props.broker
            },
            broker_loading: false,
        };
    }
    componentDidMount(){
        const { listInsurers } = this.props;
        listInsurers();
    }
    componentWillReceiveProps(nextProps){
        const { broker } = nextProps;

        this.setState({
            broker: broker || {},
            updated_broker: {
                id: broker ? broker.id : ''
            },
        });
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.setState({ broker_loading: true });
        
        const {  user } = this.props;

        const { broker, updated_broker } = this.state;

        broker.insurer = user.userInfo.insurer || broker.insurer;
       
        if(this.validator.allValid()){
            this.validator.hideMessages();
            let handler = {};

            if(broker.hasOwnProperty('id')){
                handler = this.props.updateBroker(updated_broker);
            }
            else{
                handler = this.props.saveBrokerPartnership(broker);
            }

            handler
            .then((response)=>{
                this.setState({ broker_loading: false });
            })
            .catch((error)=>{
                this.setState({ broker_loading: false });
            });
        } else{
            this.validator.showMessages();
            this.forceUpdate();
            this.setState({ broker_loading: false });
        }        
    }

    onChange = (e) => {
        e.preventDefault();

        const { updated_broker, broker } = this.state;
        const { name, value } = e.target;


        this.setState({ 
            updated_broker: {
                ...updated_broker,
                [name]: value
            },
            broker: {
                ...broker,
                [name]: value
            },
        });
    }


    render(){
        
        const { broker, broker_loading, edit } = this.state;
        const { brokers,insurers,user } = this.props;
        
        return(
            <form 
                className="form-horizontal" 
                noValidate
                onSubmit={ this.onSubmit }>
                
                {
                    brokers.errorCreateBrokerPartner && !broker_loading ?
                        <StatusMessages2 
                            type="error"
                            message={ brokers.errorMessageCreateBrokerPartner } />
                    :
                        null
                }
                {
                    brokers.success ?
                        <StatusMessages2 
                            type="success" 
                            message={ brokers.successMessage } />
                    : null
                }

                <BlankState
                    data={ false }
                    customMessage="Saving details..."
                    isDataLoading={ broker_loading } />

                <div className="form-group">
                    <label className="col-sm-4 control-label">Premium Deposit: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="number" 
                            className="form-control" 
                            name="credit_line"
                            required
                            value={ broker.credit_line || '' }
                            onChange={ this.onChange }  />
                        {this.validator.message('credit_line', broker.credit_line, 'required', 'text-danger')}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Credit Period: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="number" 
                            className="form-control" 
                            name="credit_period"
                            required
                            value={ broker.credit_period || '' }
                            onChange={ this.onChange }  />
                        {this.validator.message('credit_period', broker.credit_period, 'required', 'text-danger')}
                    </div>
                </div>

                <div className="form-group">
                    <label className="control-label col-sm-4">Intermediary: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <select 
                            name="intermediary" 
                            className="form-control"
                            required={ !edit }
                        
                            onChange={ this.onChange }>

                            <option value="">-- Select Intermediary --</option>
                            

                                {
                                    brokers.broker_admins.map( (broker,index)=>
                                        <option key={index} value={ broker.intermediary_name && broker.intermediary }>{ broker.intermediary_name}</option>
                                    )
                                }
                            
                        </select>
                        {this.validator.message('intermediary', broker.intermediary, 'required', 'text-danger')}
                    </div>
                </div>

                {
                                    !!JSON.parse(sessionStorage.user).insurer ?
                                        null
                                    :
                                        <div className="form-group">
                                            <label className="col-sm-4 control-label">Insurers: <span className="text-danger">*</span></label>
                                            <div className="col-sm-8">
                                                    <select 
                                                        className="form-control"
                                                        name="insurer"
                                                        value={broker.insurer}
                                                        onChange={ this.onChange }>
                                                        <option value="">Select Insurer</option>
                                                        {
                                                            insurers.insurers.map((insurer, index)=>{
                                                                return(
                                                                    <option key={ index } value={ insurer.id }>
                                                                        { insurer.company_name }
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                    {this.validator.message('insurer', broker.insurer, 'required', 'text-danger')}
                                            </div>
                                        </div>
                                }

                <div className="form-group">
                    <label className="col-sm-4 control-label">Commission Rate: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="number" 
                            className="form-control" 
                            name="commission_rate"
                            required
                            value={ broker.commission_rate || '' }
                            onChange={ this.onChange }  />
                        {this.validator.message('commission_rate', broker.commission_rate, 'required', 'text-danger')}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Minimum Premium: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="number" 
                            className="form-control" 
                            name="minimum_premium"
                            required
                            value={ broker.minimum_premium || '' }
                            onChange={ this.onChange }  />
                          {this.validator.message('minimum_premium', broker.minimum_premium, 'required', 'text-danger')}
                    </div>
                </div>
                <div className="col-sm-offset-4">
                    <div className="col-sm-12">
                    {
                        broker.hasOwnProperty('id') ?
                            <button className="btn btn-warning" >
                                <i className="icon ion-edit"></i>&nbsp; Update Broker Partner
                            </button>
                        :
                            <button className="btn btn-success">
                                <i className="icon ion-checkmark"></i>&nbsp; Create Broker Partner
                            </button>
                    }
                    </div>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    brokers: state.brokers,
    insurers: state.insurers
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ saveBrokerPartnership, updateBroker,listInsurers }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BrokerPartnershipsForm);


// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/BrokerPatnershipsForm.jsx